import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Grid,
	Input,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalFooter,
	ModalHeader,
	ModalOverlay,
	Select,
	Spinner,
	Text,
	useToast
} from "@chakra-ui/react"
import React, { useEffect, useRef, useState } from "react"
import { useForm, Controller } from "react-hook-form";
import { SIGNUP_MUTATION } from "../Graphql/Mutations";
import { useMutation } from '@apollo/client';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { isValidPhoneNumber } from "react-phone-number-input";

const CustomInput = React.forwardRef(({ onChange, value, ...rest }, ref) => (
	<Input
		{...rest}
		ref={ref}
		type="tel"
		value={value || ''}
		style={{ backgroundColor: "#f3f3f3" }}
		onChange={(e) => onChange(e.target.value)}
	/>
));

export function SignupModal({ isOpen, onClose, onOpenLoginModal }) {
	const toast = useToast();
	const lableStyle = {
		color: "#315b84",
		fontSize: "0.9rem",
		fontWeight: "500",
		lineHeight: "2"
	};
	const fieldStyle = {
		backgroundColor: "#f3f3f3",
	};

	const {
		control,
		handleSubmit,
		reset,
		formState: { errors },
		trigger,
		watch
	} = useForm();
	const [signupMutation, signupData] = useMutation(SIGNUP_MUTATION);

	const openLoginModal = () => {
		onClose()
		onOpenLoginModal()
	}
	const modalBodyRef = useRef();
	const [showScrollbar, setShowScrollbar] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const contentElement = modalBodyRef.current;
			if (contentElement) {
				setShowScrollbar(contentElement.scrollHeight > contentElement.clientHeight);
			}
		};

		// Attach the scroll event listener
		modalBodyRef.current?.addEventListener("scroll", handleScroll);

		// Initial check
		handleScroll();

		return () => {
			// Detach the scroll event listener on component unmount
			modalBodyRef.current?.removeEventListener("scroll", handleScroll);
		};
	}, [isOpen]);
	useEffect(() => {

		console.log("error:", signupData.error)
		console.log("loading:", signupData.loading)
		console.log("data:", signupData.data)

		if (signupData.data != undefined) {
			if (signupData?.data?.signup?.success) {
				toast({
					title: 'Succeed',
					description: 'User registered Submitted Successfully',
					status: 'success',
					duration: 4000,
					isClosable: true,
					position: "bottom-left"
				});
				reset({
					firstName: '',
					lastName: '',
					email: '',
					country: '',
					mobileNumber: '',
					password: '',
					confirmPassword: ''
				});
				openLoginModal();
			}
			else {
				toast({
					title: 'Error',
					description: signupData?.data?.signup?.message,
					status: 'error',
					duration: 4000,
					isClosable: true,
					position: "bottom-left"
				});
			}
		}

		if (signupData.error != undefined) {
			toast({
				title: 'error',
				description: signupData.error.message,
				status: 'error',
				duration: 4000,
				isClosable: true
			});
		}
	}, [signupData.data, signupData.loading, signupData.error])

	const onSubmit = (data) => {

		trigger().then(async (isValid) => {
			if (isValid) {
				console.log(data);
				const createUserInput = {
					email: data.email,
					password: data.password,
					firstName: data.firstName,
					lastName: data.lastName,
					phoneNumber: data.mobileNumber,
					country: data.country
				}

				console.log("Create user input data => ", createUserInput);
				try {
					await signupMutation({ variables: createUserInput });
				}
				catch (error) {
					console.log("Error from calling sign up mutation => ", error.message);
				}
			}
		});
	};

	return (
		<>
			<Modal
				isCentered
				isOpen={isOpen}
				onClose={onClose}
			>
				<ModalOverlay />
				<ModalContent backgroundColor={"#ececec"}>
					<ModalHeader fontSize={"32px"}>Registration</ModalHeader>
					<ModalCloseButton mt={"8px"} size={"lg"} />

					<ModalBody pb={6} style={{ overflowY: showScrollbar ? "scroll" : "hidden" }} ref={modalBodyRef}>
						<form onSubmit={handleSubmit(onSubmit)}>
							<FormControl id="firstName">
								<FormLabel {...lableStyle}>First name</FormLabel>
								<Controller
									name="firstName"
									control={control}
									defaultValue=""
									rules={{ required: "First name is required" }}
									render={({ field }) => (
										<Input {...field} {...fieldStyle} type="text" placeholder="First name" />
									)}
								/>
								{errors.firstName && <Text color="red">{errors.firstName.message}</Text>}
							</FormControl>
							<FormControl id="lastName" mt={4} >
								<FormLabel {...lableStyle}>Last name</FormLabel>
								<Controller
									name="lastName"
									control={control}
									defaultValue=""
									rules={{ required: "Last name is required" }}
									render={({ field }) => (
										<Input {...field} {...fieldStyle} type="text" placeholder="Last name" />
									)}
								/>
								{errors.lastName && <Text color="red">{errors.lastName.message}</Text>}
							</FormControl>
							<FormControl id="email" mt={4} >
								<FormLabel {...lableStyle}>Email Address</FormLabel>
								<Controller
									name="email"
									control={control}
									defaultValue=""
									rules={{ required: "Email is required" }}
									render={({ field }) => (
										<Input {...field} {...fieldStyle} placeholder="your-email@example.com" type="email" />
									)}
								/>
								{errors.email && <Text color="red">{errors.email.message}</Text>}
							</FormControl>
							<FormControl id="country" mt={4}>
								<FormLabel {...lableStyle}>Country</FormLabel>
								<Controller
									name="country"
									control={control}
									rules={{ required: "Please select your country" }}
									defaultValue=""
									render={({ field }) => (
										<Select {...field} {...fieldStyle} placeholder="Select your country">
											<option value="UAE">UAE</option>
											<option value="Pakistan">Pakistan</option>
										</Select>
									)}
								/>
								{errors.country && <Text color="red">{errors.country.message}</Text>}
							</FormControl>
							<FormControl id="mobileNumber" mt={4}>
								<FormLabel>Mobile Number</FormLabel>
								<Controller
									name="mobileNumber"
									control={control}
									defaultValue=""
									rules={{
										required: "Enter Your Mobile Number",
										validate: (value) => {
											if (!value) {
												return "Enter Your Mobile Number";
											}
											return isValidPhoneNumber(value) ? true : 'Invalid phone number';;
										},
									}}
									render={({ field }) => (
										<PhoneInput
											{...field}
											placeholder="Enter Your Mobile Number"
											defaultCountry="PK"
											countries={['AE', 'PK']}
											inputComponent={CustomInput}
										/>
									)}
								/>
								{errors.mobileNumber && <Text color="red">{errors.mobileNumber.message}</Text>}
							</FormControl>
							<FormControl id="password" mt={4} >
								<FormLabel {...lableStyle}>Password</FormLabel>
								<Controller
									name="password"
									control={control}
									defaultValue=""
									rules={{
										required: "Enter Your Password", minLength: {
											value: 6,
											message: "Password must be at least 6 characters long",
										},
									}}
									render={({ field }) => (
										<Input {...field} {...fieldStyle} placeholder="Password" type="password" />
									)}
								/>
								{errors.password && <Text color="red">{errors.password.message}</Text>}
							</FormControl>
							<FormControl id="confirmPassword" mt={4} >
								<FormLabel {...lableStyle}>Confirm Password</FormLabel>
								<Controller
									name="confirmPassword"
									control={control}
									defaultValue=""
									rules={{
										required: "Enter your confirm password",
										validate: (value) => {
											if (!value) {
												return "Enter Your confirm password";
											}
											if (value !== watch("password")) {
												return "Password and confirm password do not match.";
											}
											return true;
										},
									}}
									render={({ field }) => (
										<Input {...field} {...fieldStyle} placeholder="Confirm Password" type="password" />
									)}
								/>
								{errors.confirmPassword && <Text color="red">{errors.confirmPassword.message}</Text>}
							</FormControl>
							<Button type="submit" marginTop={"25px"} fontWeight={"500"} bg={"#002B5B"} color={"#fff"} _hover={{ bg: "#002B5B" }} w="100%">
								Signup
							</Button>
						</form>
					</ModalBody>
					<ModalFooter mb={"20px"}>
						<Grid w={"100%"}>
							<Box fontSize={"14.4px"} fontWeight={"300"}><Text>Have an account? <Text as="span" cursor="pointer" color="" onClick={openLoginModal}>Login</Text></Text></Box>
						</Grid>
					</ModalFooter>
				</ModalContent>
			</Modal>
			<Modal isOpen={signupData.loading} isCentered>
				<ModalOverlay />
				<ModalContent bg='transparent' display='flex' justifyContent='center' alignItems='center' boxShadow='none'>
					<Spinner color='blue.500' size='xl' emptyColor='gray.200' />
				</ModalContent>
			</Modal>
		</>
	)
}